import { changeState, showLayers } from 'components/ui-helper';
import { DOPrompts, DOScenes, GameType } from 'names/do-names';
import HidePromoFSonFreespins from 'slotworks/commands/promo-free-spins/hide-pfs-on-freespins';
import Components from 'slotworks/components/components';
import PromptContent from 'slotworks/components/prompt/prompt-content';
import SmartButton, { SmartButtonFlag } from 'slotworks/smart-button/smart-button';
import soundManager from 'slotworks/sound/sound-manager';
import State from 'slotworks/state-machine/states/state';
import GameInit from './game-init';
import WildSticky from './wild-sitcky';

export default class ExitTreasureBonus extends State {
    public onEnter() {
        super.onEnter();
        HidePromoFSonFreespins();
        SmartButton.setFlag(SmartButtonFlag.PROMPT, true);
        const prompt = new PromptContent([DOPrompts.EXIT_TREASURE_BONUS], 1000);
        Components.prompt.showPrompt(prompt).then(() => {
            SmartButton.setFlag(SmartButtonFlag.PROMPT, false);
            GameInit.gameType = GameType.default;
            soundManager.customEvent('start_background_ambience');
            WildSticky.setBaseContainerVisibility(true);
            this.complete();
        });
    }

    public complete() {
        showLayers();
        changeState(DOScenes.BONUS_TO_DEFAULT);
        super.complete();
    }
}



// WEBPACK FOOTER //
// ./src/states/exit-treasure-bonus.ts